// Progress percentages for each screen in the ABOUT_YOU section
const aboutYouProgress: Record<AboutYouScreenNames, number> = {
	AY_INTRO_0: 0,
	AY_INTRO_1: 0,
	Q22: 10,
	Q23: 20,
	Q23_1: 20,
	Q24: 30,
	Q25: 40,
	Q26: 50,
	Q27: 55,
	Q28: 65,
	Q28_1: 70,
	Q29: 75,
	Q30: 80,
	Q30_1: 85,
	Q31: 90,
};

export const getNextScreenAboutYou = (
	surveyState: NDS.SurveyState,
	formData: NDS.FormData,
	questionSchema: NDS.QuestionSchema,
): NDS.RouteChange => {
	const screenState = surveyState.routeStack[surveyState.routeStack.length - 1];

	switch (screenState.screen as AboutYouScreenNames) {
		// Title: About you
		case "AY_INTRO_0": {
			surveyState.routeStack.push({
				...screenState,
				route: "ABOUT_YOU",
				screen: "AY_INTRO_1",
			});
			surveyState.surveyProgress = {
				...surveyState.surveyProgress,
				ABOUT_YOU: aboutYouProgress.AY_INTRO_1,
			};
			return {
				surveyState: { ...surveyState },
				formData: { ...formData },
			};
		}
		// Title: About you
		case "AY_INTRO_1": {
			surveyState.surveyProgress = {
				...surveyState.surveyProgress,
				ABOUT_YOU: aboutYouProgress.Q22,
			};
			surveyState.routeStack.push({
				...screenState,
				route: "ABOUT_YOU",
				screen: "Q22",
			});
			return {
				surveyState: { ...surveyState },
				formData: { ...formData },
			};
		}

		// Title: How many people share your home, including you?
		case "Q22": {
			const userAnswer = formData.nds_q_22_number_of_people;

			const options = questionSchema.ABOUT_YOU.Q22.fields[0].options;

			const userAnswerIndex = options.findIndex(
				({ value }) => value === userAnswer,
			);

			// If either 1 or 7 or more go to Q23
			if (
				!userAnswer ||
				userAnswerIndex === 0 ||
				userAnswerIndex === options.length - 1
			) {
				surveyState.routeStack.push({
					...screenState,
					route: "ABOUT_YOU",
					screen: "Q23",
				});
				surveyState.surveyProgress = {
					...surveyState.surveyProgress,
					ABOUT_YOU: aboutYouProgress.Q23,
				};
				return {
					surveyState,
					formData,
				};
			}

			// Otherwise go to Q23_1
			surveyState.routeStack.push({
				...screenState,
				route: "ABOUT_YOU",
				screen: "Q23_1",
			});
			surveyState.surveyProgress = {
				...surveyState.surveyProgress,
				ABOUT_YOU: aboutYouProgress.Q23_1,
			};
			return {
				surveyState,
				formData: {
					...formData,
					Q23: `${userAnswerIndex}`,
				},
			};
		}

		// Title: How old are you?
		case "Q23": {
			surveyState.routeStack.push({
				...screenState,
				route: "ABOUT_YOU",
				screen: "Q24",
			});
			surveyState.surveyProgress = {
				...surveyState.surveyProgress,
				ABOUT_YOU: aboutYouProgress.Q24,
			};
			return {
				surveyState: { ...surveyState },
				formData: { ...formData },
			};
		}

		// Title: How old are the people you live with?
		case "Q23_1": {
			surveyState.routeStack.push({
				...screenState,
				route: "ABOUT_YOU",
				screen: "Q24",
			});
			surveyState.surveyProgress = {
				...surveyState.surveyProgress,
				ABOUT_YOU: aboutYouProgress.Q24,
			};
			return {
				surveyState: { ...surveyState },
				formData: { ...formData },
			};
		}

		// Title: Which of these best describes your gender identity?
		case "Q24": {
			surveyState.routeStack.push({
				...screenState,
				route: "ABOUT_YOU",
				screen: "Q25",
			});
			surveyState.surveyProgress = {
				...surveyState.surveyProgress,
				ABOUT_YOU: aboutYouProgress.Q25,
			};
			return {
				surveyState: { ...surveyState },
				formData: { ...formData },
			};
		}

		// Title: What's your ethnic group?
		case "Q25": {
			surveyState.routeStack.push({
				...screenState,
				route: "ABOUT_YOU",
				screen: "Q26",
			});
			surveyState.surveyProgress = {
				...surveyState.surveyProgress,
				ABOUT_YOU: aboutYouProgress.Q26,
			};
			return {
				surveyState: { ...surveyState },
				formData: { ...formData },
			};
		}

		// Title: What's your highest level of education?
		case "Q26": {
			surveyState.routeStack.push({
				...screenState,
				route: "ABOUT_YOU",
				screen: "Q27",
			});
			surveyState.surveyProgress = {
				...surveyState.surveyProgress,
				ABOUT_YOU: aboutYouProgress.Q27,
			};
			return {
				surveyState: { ...surveyState },
				formData: { ...formData },
			};
		}

		// Title: How would you describe yourself?
		case "Q27": {
			surveyState.routeStack.push({
				...screenState,
				route: "ABOUT_YOU",
				screen: "Q28",
			});
			surveyState.surveyProgress = {
				...surveyState.surveyProgress,
				ABOUT_YOU: aboutYouProgress.Q28,
			};
			return {
				surveyState: { ...surveyState },
				formData: { ...formData },
			};
		}

		// Title: Which region do you live in?
		case "Q28": {
			const answer = formData.nds_q_28_region;
			const options = questionSchema.ABOUT_YOU.Q28.fields[0].options;
			const answerIndex = options.findIndex(({ value }) => value === answer);
			const otherAnswerIndex = options.length - 1;
			const preferNotToSayIndex = options.length - 2;

			if (
				answer &&
				![otherAnswerIndex, preferNotToSayIndex].includes(answerIndex)
			) {
				surveyState.routeStack.push({
					...screenState,
					route: "ABOUT_YOU",
					screen: "Q28_1",
				});
				surveyState.surveyProgress = {
					...surveyState.surveyProgress,
					ABOUT_YOU: aboutYouProgress.Q28_1,
				};
			} else {
				surveyState.routeStack.push({
					...screenState,
					route: "ABOUT_YOU",
					screen: "Q29",
				});
				surveyState.surveyProgress = {
					...surveyState.surveyProgress,
					ABOUT_YOU: aboutYouProgress.Q29,
				};
			}
			return {
				surveyState: { ...surveyState },
				formData: { ...formData },
			};
		}

		// Title: What does your postcode begin with?
		case "Q28_1": {
			surveyState.routeStack.push({
				...screenState,
				route: "ABOUT_YOU",
				screen: "Q29",
			});
			surveyState.surveyProgress = {
				...surveyState.surveyProgress,
				ABOUT_YOU: aboutYouProgress.Q29,
			};
			return {
				surveyState: { ...surveyState },
				formData: { ...formData },
			};
		}

		// Title: Which of these best describes your housing situation?
		case "Q29": {
			if (screenState.dogCount === 0) {
				// If they have no dog go to no dog version of Q30 (Q30_1)
				surveyState.routeStack.push({
					...screenState,
					route: "ABOUT_YOU",
					screen: "Q30_1",
				});
				surveyState.surveyProgress = {
					...surveyState.surveyProgress,
					ABOUT_YOU: aboutYouProgress.Q30,
				};
				return {
					surveyState,
					formData,
				};
			}

			// Otherwise go to the dog version of Q30 (Q30)
			surveyState.routeStack.push({
				...screenState,
				route: "ABOUT_YOU",
				screen: "Q30",
			});
			surveyState.surveyProgress = {
				...surveyState.surveyProgress,
				ABOUT_YOU: aboutYouProgress.Q30_1,
			};
			return {
				surveyState: { ...surveyState },
				formData: { ...formData },
			};
		}

		// Title: Which of these hobbies and interests do you enjoy?
		case "Q30": {
			surveyState.routeStack.push({
				...screenState,
				route: "ABOUT_YOU",
				screen: "Q31",
			});
			surveyState.surveyProgress = {
				...surveyState.surveyProgress,
				ABOUT_YOU: aboutYouProgress.Q31,
			};
			return {
				surveyState: { ...surveyState },
				formData: { ...formData },
			};
		}

		// Title: Which of these hobbies and interests do you enjoy?
		case "Q30_1": {
			surveyState.routeStack.push({
				...screenState,
				route: "ABOUT_YOU",
				screen: "Q31",
			});
			surveyState.surveyProgress = {
				...surveyState.surveyProgress,
				ABOUT_YOU: aboutYouProgress.Q31,
			};
			return {
				surveyState: { ...surveyState },
				formData: { ...formData },
			};
		}

		// Title: Would you like to stay updated on the results of this survey?
		case "Q31": {
			if (screenState.dogCount > 1) {
				surveyState.routeStack.push({
					...screenState,
					route: "SUBSEQUENT_DOG",
					screen: "Q32",
				});
				surveyState.surveyProgress = {
					...surveyState.surveyProgress,
					ABOUT_YOU: 100,
				};
				return {
					surveyState,
					formData,
					transition: "ABOUT_YOU",
				};
			}

			surveyState.routeStack.push({
				...screenState,
				route: "GLOBAL",
				screen: "END_OF_SURVEY",
			});
			surveyState.surveyProgress = {
				...surveyState.surveyProgress,
				ABOUT_YOU: 100,
			};
			return {
				surveyState: { ...surveyState },
				formData: { ...formData },
				transition:
					screenState.dogCount === 0 ? "ABOUT_YOU_NON_DOG_OWNER" : "ABOUT_YOU",
			};
		}
	}
};
